import { withStyles } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import styled from "@material-ui/core/styles/styled";
import { div } from "lqx-react/lib/common";
import { Column, Columns } from "lqx-react/lib/forms/layout";

export const useAssetTileClasses = makeStyles({
    root: {
        backgroundColor: '#f5f7f9',
        border: '1px solid',
        borderColor: (props: any) => props.isSelected ? '#4197d6' : 'white',
        borderRadius: '5px'
    }
});

export const FirstColumn = styled(Column)({
    minWidth: '250px',
    maxWidth: '250px',
    marginRight: '3px'
});

export const EventsColumn = styled(Column)({
    marginTop: '10px',
    minWidth: '75px',
    maxWidth: '75px',
    marginRight: '1px',
    marginLeft: '1px'
});

export const SecondColumn = styled(Column)({
    minWidth: '0px',
    maxWidth: '300px'
});

export const AssetsCollapsableSection = div({
    '& .MuiAccordionSummary-content span': {
        textTransform: 'none',
        fontSize: 'clamp(12px, 0.9vw, 18px)'
    },
    '& .MuiAccordionSummary-content span:first-child': {
        width: '100%',
    }
});


export const AssetTileField = div({
    paddingBottom: '5px',
    paddingTop: '5px',
    minWidth: 140,
    maxWidth: 140,
    display: 'flex',
    fontFamily: 'Montserrat',
    fontSize: 10,
    marginRight: '1em',
    color: 'black',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'

});

export const AssetTileHeaderField = div({
    paddingBottom: '5px',
    paddingTop: '5px',
    display: 'block',
    fontFamily: 'Montserrat',
    fontSize: 12,
    marginRight: '1em',
    color: '#052C4C',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'

});

export const AssetTileStatusField = div({
    paddingBottom: '5px',
    paddingTop: '5px',
    display: 'block',
    fontFamily: 'Montserrat',
    fontSize: 12,
    marginRight: '1em',
    color: '#052C4C',
    fontWeight: 600,
    whiteSpace: 'nowrap'

});

export const CheckboxColumn = styled(Column)({
    flex: '0 0 0',
    paddingTop: '10px',
    margin: '0px',
    paddingLeft: '0px',
    paddingRight: '0px',
    maxWidth: '20px'
});

export const TileContainer = withStyles({
    root: {
        paddingLeft: '15px',
        paddingTop: '7px',
    }
})(Columns)
